import { absoluteUrl } from "@/lib/utils";

import type { BlogDetail, BlogListItem } from "../types/blog.types";

const BLOG_IMAGE_FALLBACK = "/images/hero-section.webp";

export function getBlogImageUrl(path?: string | null) {
  if (!path) {
    return BLOG_IMAGE_FALLBACK;
  }

  return absoluteUrl(path, true);
}

export function getAuthorPhotoUrl(path?: string | null) {
  if (!path) {
    return null;
  }

  return absoluteUrl(path, true);
}

export function getAuthorInitials(name?: string | null) {
  if (!name) {
    return "BE";
  }

  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

export function stripHtmlTags(value?: string | null) {
  if (!value) {
    return "";
  }

  return value
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\s+/g, " ")
    .trim();
}

export function getBlogSummary(
  post: Pick<BlogListItem, "excerpt"> | Pick<BlogDetail, "content_text" | "excerpt">,
) {
  if (post.excerpt?.trim()) {
    return post.excerpt.trim();
  }

  if ("content_text" in post) {
    return post.content_text.trim();
  }

  return "";
}

export function getReadingTimeMinutes(value?: string | null) {
  const plainText = stripHtmlTags(value);
  const words = plainText.split(/\s+/).filter(Boolean).length;

  if (!words) {
    return 1;
  }

  return Math.max(1, Math.ceil(words / 220));
}

export function buildBlogContentHtml(
  post: Pick<BlogDetail, "content_html" | "content_text" | "excerpt">,
) {
  if (post.content_html?.trim()) {
    return post.content_html;
  }

  const paragraphs = (post.content_text || post.excerpt)
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

  return paragraphs.map((paragraph) => `<p>${paragraph}</p>`).join("");
}
